import * as types from './reports_action_type'
import { urls } from '../../components/common/constants'
import { updateAlertError, updateLoader } from '../common/common_action'
import { GetRequest, GetRequestCached, GetRequestCachedV3, PostRequest } from '../../components/common/api'
import { addMisssingValue } from '../../components/common/helper'
export const updateOwnChildBranches = (data) => {
  return { type: types.OWN_AND_CHILD_BRANCHES, data }
}
export const updateOwnChildBranches1 = (data) => {
  return { type: types.OWN_AND_CHILD_BRANCHES_ONE, data }
}
export const updateOwnChildUsers = (data) => {
  return { type: types.OWN_AND_CHILD_USERS, data }
}
export const updateReportCompanyList = (data) => {
  return { type: types.REPORT_COMPANY, data }
}
export const updateFranchiseeCompanyList = (data) => {
  return { type: types.FRANCHISEE_COMPANY, data }
}
export const updateReportCompanyListV2 = (data) => {
  return { type: types.REPORT_COMPANYV2, data }
}
export const updateFranchiseeCompanyListV2 = (data) => {
  return { type: types.FRANCHISEE_COMPANYV2, data }
}
export const updateFranchiseeBranchList = (data) => {
  return { type: types.FRANCHISEE_BRANCH, data }
}
export const updatePartyBookingFilter = (data) => {
  return { type: types.PARTY_BOOKING_FILTER, data }
}
export const updatePartyBookingData = (data) => {
  return { type: types.PARTY_BOOKING_DATA, data }
}
export const setOnAccountReportData = (data) => ({
  type: types.ON_ACCOUNT_REPORT_DATA,
  data,
})
export const setReportBranchList = (data) => ({
  type: types.REPORT_BRANCH_LIST,
  data,
})

export const setCreditTransTableData = (data) => ({
  type: types.CREDIT_TRANSACTION_DATA,
  data,
})
export const setPartyCreditLimitTransTableData = (data) => ({
  type: types.PARTY_CREDIT_TRANSACTION_DATA,
  data,
})

export const setCreditSummaryTableData = (data) => ({
  type: types.CREDIT_SUMMARY_DATA,
  data,
})
export const setPartyCreditLimitSummaryTableData = (data) => ({
  type: types.PARTY_CREDIT_LIMIT_SUMMARY_DATA,
  data,
})


export const setCreditUsageTableData = (data) => ({
  type: types.CREDIT_Usage_DATA,
  data,
})
export const setPartCreditUsageTableData = (data) => ({
  type: types.PARTY_CREDIT_Usage_DATA,
  data,
})

export const updateAnalysisReportFilter = (data) => {
  return { type: types.ANALYSIS_FILTER, data }
}
export const updateGstInvoiceData = (data) => {
  return { type: types.GST_INVOICE, data }
}
export const updateBranchListConfig = (data) => {
  return { type: types.BRANCH_LIST_CONFIG, data }
}
export const updateDispatchFilters = (data) => ({ type: types.DISPATCH_FILTER, data })

export const updateBranchTransferFitler = (data) => ({ type: types.BRANCH_TRANSFER, data })
export const updateBranchReceiveFitler = (data) => ({ type: types.BRANCH_RECEIVE, data })
export const updateOwnBooingFitlerData = (data) => ({ type: types.OWN_BOOKING_REPORT_DROP_DATA, data })
export const updateGoodsBalanceFilterData = (data) => ({ type: types.BRANCH_STOCK_FILTER_DATA, data })
export const updateOwnBooingTableData = (data) => ({ type: types.OWN_BOOKING_REPORT_DATA, data })
//gst report
export const updategstReportFitlerData = (data) => ({ type: types.GST_REPORT_FILTER_DATA, data })
export const updategstReportDetailData = (data) => ({ type: types.GST_REPORT_DETAIL_DATA, data })
export const updategstReportSummaryData = (data) => ({ type: types.GST_REPORT_Summary_DATA, data })

//DISPATCH REPORT ACTION
export const updateDispatchReportDetailsFilter = (data) => {
  return { type: types.DISPATCH_DETAILS, data }
}
export const updateDispatchReportDetailsData = (data) => {
  return { type: types.DISPATCH_DETAILS_DATA, data }
}
export const updateChallanWiseDispatchData = (data) => {
  return { type: types.CHALLAN_WISE_DISPATCH_DATA, data }
}
export const updateDispatchReportSummaryData = (data) => {
  return { type: types.DISPATCH_SUMMARY_DATA, data }
}
export const updateDispatchMemoDetailData = (data) => {
  return { type: types.DISPATCH_MEMODETAIL_DATA, data }
}

export const updateUserWiseCollData = (data) => {
  return { type: types.USER_WISE_COLLECTION, data }
}
export const updateFranchiseeToOwn = (data) => {
  return { type: types.FRANCHISEE_TO_OWN, data }
}
export const updateBookingFilterData = (data) => {
  return { type: types.BOOKING_FILTER_DATA, data }
}
export const updateAnalysisTableData = (data) => {
  return { type: types.ANALYSIS_TABLE_DATA, data }
}
export const updateCargoSettingFilter = (data) => {
  return { type: types.CARGO_SETTING_FILTER, data }
}
export const updateReceivedDropData = (data) => {
  return { type: types.RECEIVED_DROP_DATA, data }
}
export const updateReceivedTableData = (data) => {
  return { type: types.RECEIVED_TABLE_DATA, data }
}
export const updateBookingFranchiseeData = (data) => {
  return { type: types.BOOKING_FRANCHISEE_DATA, data }
}
export const updateGoodBalDropData = (data) => {
  return { type: types.GOODBAL_DROP_DATA, data }
}
export const updateGoodBalTableData = (data) => {
  return { type: types.GOODBAL_TABLE_DATA, data }
}
export const updateBranchStockTableData = (data) => {
  return { type: types.BRANCHSTOCK_TABLE_DATA, data }
}
export const updateFranchiseOutstandingTableData = (data) => {
  return { type: types.FRANCHISE_OUTSTANDING_TABLE_DATA, data }
}
export const updateFranchiseOutstandingTableFilterData = (data) => {
  return { type: types.FRANCHISE_OUTSTANDING_TABLE_FILTER_DATA, data }
}
export const updateQuikViewTableData = (data) => {
  return { type: types.QUIKVIEW_TABLE_DATA, data }
}
export const updateEwayBookingFilter = (data) => {
  return { type: types.EWAY_BOOKING_FILTER, data }
}
export const updateEwayBookingData = (data) => {
  return { type: types.EWAY_BOOKING_DATA, data }
}
export const updateTrackingReportFilter = (data) => {
  return { type: types.TRACKING_REPORT_FILTER, data }
}
export const updateTrackingReportData = (data) => {
  return { type: types.TRACKING_REPORT_DATA, data }
}
export const updateDeliveryReportFilterData = (data) => {
  return { type: types.DELIVERY_FILTER_DATA, data }
}
export const updateDeliveryReportTableData = (data) => {
  return { type: types.DELIVERY_TABLE_DATA, data }
}
export const updateLrCancelPenaltyReportFilterData = (data) => {
  return { type: types.LR_CANCEL_AND_PENALTY_REPORT_FILTER_DATA, data }
}
export const updateLrCancelPenaltyReportTableData = (data) => {
  return { type: types.LR_CANCEL_AND_PENALTY_REPORT_TABLE_DATA, data }
}
export const updateCargoUnloadingTableData = (data) => {
  return { type: types.CARGO_UNLOADING_TABLE_DATA, data }
}
export const updateDispVehicleTableData = (data) => {
  return { type: types.DISP_VEHICLENO_DATA, data }
}
export const updateUserWithTransRightReportTableData = (data) => {
  return { type: types.USER_WIth_TRANS_RIGHT_REPORT_TABLE_DATA, data }
}
export const updateRechargePenaltyReportTableData = (data) => {
  return { type: types.RECHAGE_PENALTY_REPORT_TABLE_DATA, data }
}
export const updatePartyTartgetAchivementyReportTableData = (data) => {
  return { type: types.PARTY_TARGET_ACHIVEMENT_REPORT_TABLE_DATA, data }
}
export const updateToPayDestinationReportTableData = (data) => {
  return { type: types.TO_PAY_DESTINATION_REPORT_TABLE_DATA, data }
}
export const updateReceiptRegisterFilterData = (data) => {
  return { type: types.RECEIPT_RESITER_FILTER, data }
}
export const updateReceiptRegisterReportTableData = (data) => {
  return { type: types.RECEIPT_REGISTER_REPORT_TABLE_DATA, data }
}
export const updatePenaltyTargetAchivementReportFilterData = (data) => {
  return { type: types.PENALTY_TARGET_ACHIVEMENT_REPORT_FILTER_DATA, data }
}
export const updateLuggageModificationReportData = (data) => {
  return { type: types.LUGGAGE_MODIFICATION_REPORT, data }
}
export const updateLrDetailsPopupV2Data = (data) => {
  return { type: types.LR_DETAILS_FOR_POPUP_V2, data }
}
export const updateCargoSettingData = (data) => {
  return { type: types.GET_CARGO_SETTING, data }
}
export const updateDispatchResisterFilterData = (data) => {
  return { type: types.DISPATCH_RESITER_FILTER, data }
}
export const updateDispatchResisterTableData = (data) => {
  return { type: types.DISPATCH_RESITER_TABLE_DATA, data }
}
export const updateDispatchResisterVehicleWiseTableData = (data) => {
  return { type: types.DISPATCH_RESITER_TABLE_VEHICLE_WISE_DATA, data }
}
export const updateDispatchResisterMemoTable = (data) => {
  return { type: types.DISPATCH_RESITER_MEMO_TABLE, data }
}
export const updateToPayStatementReport = (data) => {
  return { type: types.TO_PAY_STATEMENT_REPORT, data }
}
export const updateMpesaTransactionReportData = (data) => {
  return { type: types.MPESA_TRANSACTION_REPORT, data }
}




export const getOwnChildBranches = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getOwnAndChildBranchList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateOwnChildBranches(res.Data.Table))
        dispatch(updateOwnChildBranches1(res.Data.Table1))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getOwnChildUsers = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getOwnAndChildUsersList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateOwnChildUsers(res.Data.Table))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getCompanyList = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  const { intMode } = data
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getFranchiseeCompanyList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (intMode === 0) {
          dispatch(updateReportCompanyList(res.Data.Table))
        } else {
          dispatch(updateFranchiseeCompanyList(res.Data.Table))
        }
      }
    })
    .catch((err) => {
      updateLoader(false)
    })
}
export const getFranchiseeBranchList = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFranchiseeBranchList, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateFranchiseeBranchList(res.Data.Table))
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
export const getDispatchReportInputFilters = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchReportFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res.Data.Table.length) {
          dispatch(updateDispatchFilters(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' }))
          dispatch(updateDispatchFilters({}))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
//dispatch Report
export const getDispatchReportDetailsFilter = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchDetailsFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res.Data.Table.length > 0) {
          dispatch(updateDispatchReportDetailsFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' }))
          dispatch(updateDispatchReportDetailsFilter([]))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
export const getDispatchReportDetailsData = (data,UseToPayAsCOD ) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchDetailsFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res.Data.Table.length) {
          const updatedData = {
            ...res,
            Data: {
              ...res.Data,
              Table: res.Data.Table.map((item) => ({
                ...item,
                PaymentType:
                  UseToPayAsCOD === 1 &&
                    item.PaymentTypeInt === 2 &&
                    item.PaymentType === 'TO PAY'
                    ? 'COD'
                    :item.PaymentTypeInt === 7?'COD(MANUAL)':item.PaymentType,
              })),
            },
          };
          dispatch(updateDispatchReportDetailsData(updatedData))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' }))
          dispatch(updateDispatchReportDetailsData([]))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
export const getChallanWiseDispatchData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getChallanWiseDispatchData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res.Data.Table.length) {
          dispatch(updateChallanWiseDispatchData(res))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No records found', nextId: '' }))
          dispatch(updateChallanWiseDispatchData([]))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
export const getDispatchReportSummaryFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchReportSummaryFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res?.Data?.Table?.length) {
          dispatch(updateDispatchReportSummaryData(res))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' }))
          dispatch(updateDispatchReportSummaryData([]))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
export const getDispatchMemoDetailFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchMemoDetailFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res?.Data?.Table?.length) {
          const updatedRes = addMisssingValue(res?.Data?.Table)
          dispatch(updateDispatchMemoDetailData(updatedRes))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Dispatch In Selected Date', nextId: '' }))
          dispatch(updateDispatchMemoDetailData([]))
        }
      }
    })
    .catch((err) => dispatch(updateLoader(false)))
}
//Go button click for partyBooking
export const getPartyBookingFilter = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyBookingRptFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (res.Data.Table.length) {
          dispatch(updatePartyBookingFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
          dispatch(updatePartyBookingFilter([]))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

//Go button click for Analysis Report
export const getAnalysisReportFilter = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getAnalysisReportFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (res.Data.Table.length) {
          dispatch(updateAnalysisReportFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getBranchTransferFilter = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchTransferFilter, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getBranchConfig = (data) => (dispatch) => {
  PostRequest(urls.getBranchConfigOrEwbillinfo, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateBranchListConfig(res.Data.Table[0]))
      } else {
        dispatch(updateBranchListConfig([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getBranchReceiveFilter = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchReceiveFilter, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getGstInvoiceData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGstInvoiveData, obj)
    .then((res) => {
      dispatch(updateLoader(false))

      if (res.status == 'Success') {
        dispatch(updateGstInvoiceData(res))
      } else {
        dispatch(updateGstInvoiceData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}
export const getBranchWiseCollectionData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchWiseCollectionData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
      })
  })
}
export const getNonMovementFilterData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getNonMovementFilterData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        // console.log(error, "error")
      })
  })
}
//gst report api

export const getgstReportFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getgstReportFilterData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updategstReportFitlerData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getgstReportDetailData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getgstReportDetailData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updategstReportDetailData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getgstReportSummaryData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getgstReportSummaryData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updategstReportSummaryData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getOwnBookingFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getOwnBookingFilterData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateOwnBooingFitlerData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getOwnBookingTableData = (data,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getOwnBookingReportData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const updatedData = {
          ...res,
          Data: {
            ...res.Data,
            Table1: res.Data.Table1.map((item) => ({
              ...item,
              PayType:
                UseToPayAsCOD === 1 &&
                  item.PaymentTypeID === 2
                  ? "COD"
                  : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PayType,
            })),
            Table: res.Data.Table.map((item) => ({
              ...item,
              PayType:
                UseToPayAsCOD === 1 &&
                  item.PaymentTypeID === 2
                  ? "COD"
                  : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PayType,
            })),
          },
        };
        dispatch(updateOwnBooingTableData(updatedData))
        // dispatch(updateOwnBooingTableData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUserWiseCollData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getUserWiseCollection, obj)
    .then((res) => {
      dispatch(updateLoader(false))

      if (res.status == 'Success') {
        dispatch(updateUserWiseCollData(res))
      } else {
        dispatch(updateUserWiseCollData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}
//BookingFranchiseeReport
export const getFranchiseeToOwnReport = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.BookingFranchiseeReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateFranchiseeToOwn(res))
      } else {
        dispatch(updateFranchiseeToOwn([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}
//BookingFilterData
export const BookingFilterData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.BookingFilterData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateBookingFilterData(res))
      } else {
        dispatch(updateBookingFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}

export const getCargoSettingFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getCargoSetting, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCargoSettingFilter(res.Data))
      } else {
        dispatch(updateCargoSettingFilter([]))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateCargoSettingFilter([]))
    })
}
//Party Booking Apis
export const getPartyBookingFilterData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyBookingReportFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (res.Data.Table.length) {
          dispatch(updatePartyBookingFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
          dispatch(updatePartyBookingFilter([]))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getPartyBookingTableData = (obj,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyBookingData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        let responseData = res.Data;
        if (UseToPayAsCOD === 1 && responseData?.Table?.length > 0) {
          responseData = {
            ...responseData,
            Table: responseData.Table.map((item) => {
              let newPaymentType = item.PayType;
              if (item.PayType === 'TOPAY') newPaymentType = 'COD';
              else if (item.PayType === 'TOPAY(MANUAL)') newPaymentType = 'COD(MANUAL)';
              else if (item.PayType === 'ToPayDDDV') newPaymentType = 'COD(DDDV)';
              else if (item.PayType === 'To-Pay Credit') newPaymentType = 'COD Credit';
              return { ...item, PayType: newPaymentType };
            }),
          };
        }
        dispatch(updatePartyBookingData(responseData))
      } else {
        dispatch(updatePartyBookingData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}

//received report api
export const getReceivedDropData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceivedDropData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateReceivedDropData(res))
        if (res?.Data?.Table?.length > 0) {
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' }))
        }
      } else {
        dispatch(updateReceivedDropData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateReceivedDropData([]))
    })
}
export const getReceivedTableData = (obj,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceivedTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const updatedData = {
          ...res,
          Data: {
            ...res.Data,
            Table: res.Data.Table.map((item) => ({
              ...item,
              PaymentType:
                UseToPayAsCOD === 1 &&
                item.PaymentTypeInt === 2 
                  ? "COD"
                  :item.PaymentTypeInt === 7?'COD(MANUAL)':item.PaymentType,
            })),
            Table2: res.Data.Table2.map((item) => ({
              ...item,
              PaymentType:
                UseToPayAsCOD === 1 &&
                item.PaymentTypeID === 2 
                  ? "COD"
                  :item.PaymentTypeID === 7?'COD(MANUAL)':item.PaymentType,
            })),
          },
        };
        dispatch(updateReceivedTableData(updatedData))
      } else {
        dispatch(updateReceivedTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateReceivedTableData({}))
    })
}
export const getBookingFranchiseeTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getBookingFranchiseeData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateBookingFranchiseeData(res.Data))
      } else {
        dispatch(updateBookingFranchiseeData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
    })
}

//onAccount Report
export const getOnAccountCreditReport = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getOnAccountCreditReport, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setOnAccountReportData(res))
      } else {
        dispatch(setOnAccountReportData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setOnAccountReportData([]))
    })
}
//branchList for Credit report
export const getReportBranchList = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReportBranchList, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setReportBranchList(res?.Data?.Table))
      } else {
        dispatch(setReportBranchList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setReportBranchList([]))
    })
}
// branch credit transaction report
export const getCreditTransactionData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCreditTransactionData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setCreditTransTableData(res?.Data?.Table))
      } else {
        dispatch(setCreditTransTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setCreditTransTableData([]))
    })
}

// branch credit summary report
export const getCreditSummaryData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCreditSummaryData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setCreditSummaryTableData(res?.Data))
      } else {
        dispatch(setCreditSummaryTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setCreditSummaryTableData([]))
    })
}
export const getCreditUsageData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCreditUsageData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setCreditUsageTableData(res?.Data?.Table))
      } else {
        dispatch(setCreditUsageTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setCreditUsageTableData([]))
    })
}
export const getPartyCreditUsageReportData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyCreditUsageReport, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setPartCreditUsageTableData(res?.Data?.Table))
      } else {
        dispatch(setPartCreditUsageTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setPartCreditUsageTableData([]))
    })
}
// good balance report actions
export const getGoodBalDropData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getgoodBalDropData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateGoodBalDropData(res))
      } else {
        dispatch(updateGoodBalDropData({}))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateGoodBalDropData({}))
    })
}
export const getGoodBalTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGoodBalTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateGoodBalTableData(res))
      } else {
        dispatch(updateGoodBalTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateGoodBalTableData({}))
    })
}
export const getBranchStockTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getBranchStockTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateBranchStockTableData(res))
      } else {
        dispatch(updateBranchStockTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateBranchStockTableData({}))
    })
}
export const getFranchiseOutstandingTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFranchiseOutstandingTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateFranchiseOutstandingTableData(res))
      } else {
        dispatch(updateFranchiseOutstandingTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateFranchiseOutstandingTableData({}))
    })
}
export const getFranchiseOutstandingTableFiltersData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFranchiseOutstandingTableFiltersData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateFranchiseOutstandingTableFilterData(res))
      } else {
        dispatch(updateFranchiseOutstandingTableFilterData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateFranchiseOutstandingTableFilterData({}))
    })
}
export const getQuikViewTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getQuikViewTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateQuikViewTableData(res))
      } else {
        dispatch(updateQuikViewTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateQuikViewTableData({}))
    })
}
// Eway Bill Report Api
export const getEwayBookingReportFilters = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getEwayBookingFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (res?.Data?.Table?.length) {
          dispatch(updateEwayBookingFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
          dispatch(updateEwayBookingFilter([]))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
        dispatch(updateEwayBookingFilter([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateEwayBookingFilter([]))
    })
}

export const getEwayBookingReportTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getEwayBookingData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateEwayBookingData(res.Data))
      } else {
        dispatch(updateEwayBookingData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateEwayBookingData([]))
    })
}

export const getTrackingReportFilters = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getTrackingReportFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (res?.Data?.Table?.length) {
          dispatch(updateTrackingReportFilter(res.Data.Table))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
          dispatch(updateTrackingReportFilter([]))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
        dispatch(updateTrackingReportFilter([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateTrackingReportFilter([]))
    })
}

export const getTrackingReportTableData = (obj,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getTrackingReportData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const data=res?.Data?.Table?.map((item)=>({...item,PaymentType:UseToPayAsCOD===1&&item.PaymentType==="To-Pay"?'COD':item.PaymentType==='To-Pay(MANUAL)'?'COD(MANUAL)':item.PaymentType==='To-Pay(DDDV)'?'COD(DDDV)':item.PaymentType}))
        dispatch(updateTrackingReportData(data))
      } else {
        dispatch(updateTrackingReportData([]))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateTrackingReportData([]))
    })
}
export const getDeliveryReportFilterData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDeliveryReportFilterData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDeliveryReportFilterData(res.Data))
      } else {
        dispatch(updateDeliveryReportFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }

    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDeliveryReportFilterData([]))
    })
}
export const getDeliveryReportTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDeliveryReportTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDeliveryReportTableData(res.Data))
      } else {
        dispatch(updateDeliveryReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDeliveryReportTableData([]))
    })
}

export const getLRPenaltyReportFilterData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getLRPenaltyReportFilterData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateLrCancelPenaltyReportFilterData(res.Data))
      } else {
        dispatch(updateLrCancelPenaltyReportFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateLrCancelPenaltyReportFilterData([]))
    })
}
export const getLRPenaltyReportTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getLRPenaltyReportTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateLrCancelPenaltyReportTableData(res.Data))
      } else {
        dispatch(updateLrCancelPenaltyReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateLrCancelPenaltyReportTableData([]))
    })
}
// Cargo Unloading Report
export const getCargoUnloadingTblData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCargoUnloadingRptTblData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateCargoUnloadingTableData(res.Data.Table))
      } else {
        dispatch(updateCargoUnloadingTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateCargoUnloadingTableData([]))
    })
}

export const getDispatchedVehicleData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispVehicleNoData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDispVehicleTableData(res.Data.Table))
      } else {
        dispatch(updateDispVehicleTableData([]))
        // dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDispVehicleTableData([]))
    })
}
export const getFranchiseeDeliveryReportFilterData = (obj) => (dispatch) => {
    return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getFranchiseeDeliveryReportFilterData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getFranchiseeDeliveryReportTableData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFranchiseeDeliveryReportTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}
//party credit transaction report
export const getPartyCreditLimitTransRptData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyCreditLimitTransReportData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setPartyCreditLimitTransTableData(res?.Data?.Table))
      } else {
        dispatch(setPartyCreditLimitTransTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setPartyCreditLimitTransTableData([]))
    })
}
//party credit summary report
export const getPartyCreditLimitSummaryData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyCreditLimitSummaryData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(setPartyCreditLimitSummaryTableData(res?.Data))
      } else {
        dispatch(setPartyCreditLimitSummaryTableData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setPartyCreditLimitSummaryTableData([]))
    })
}
export const getUserWithTransRightReportTableData = (obj,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getUserWithTransRightReportTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const data =res?.Table.map((item)=>({...item,PaymentType:UseToPayAsCOD===1&&item.PaymentTypeId===2?'COD':item.PaymentTypeId===7?'COD(MANUAL)':item.PaymentTypeId===9?'COD(DDDV)':item.PaymentType}))
        dispatch(updateUserWithTransRightReportTableData(data))
      } else {
        dispatch(updateUserWithTransRightReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateUserWithTransRightReportTableData([]))
    })
}
export const getRechargePenaltyReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getRechargePenaltyReportData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateRechargePenaltyReportTableData(res?.Table))
      } else {
        dispatch(updateRechargePenaltyReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateRechargePenaltyReportTableData([]))
    })
}
export const getPatyTargetAchivementReportFilterData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPatyTargetAchivementReportFilterData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updatePenaltyTargetAchivementReportFilterData(res?.Data?.Table))
      } else {
        dispatch(updatePenaltyTargetAchivementReportFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updatePenaltyTargetAchivementReportFilterData([]))
    })
}
export const getPartyTargetAchivementReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPartyTargetAchivementReportData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updatePartyTartgetAchivementyReportTableData(res?.Data?.Table))
      } else {
        dispatch(updatePartyTartgetAchivementyReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updatePartyTartgetAchivementyReportTableData([]))
    })
}
export const getLuggageModificationReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getLuggageModificationReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateLuggageModificationReportData(res?.Data?.table))
      } else {
        dispatch(updateLuggageModificationReportData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateLuggageModificationReportData([]))
    })
}
export const GetLRDetailsForPopUpV2Data = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.GetLRDetailsForPopUpV2, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateLrDetailsPopupV2Data(res?.Data?.table))
      } else {
        dispatch(updateLrDetailsPopupV2Data([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateLrDetailsPopupV2Data([]))
    })
}
export const GetCargoSettingData = (data) => (dispatch) => {
  PostRequest(urls.getCargoSetting, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateCargoSettingData(res.Data))
      } else {
        dispatch(updateCargoSettingData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getToPayDestinationReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getToPayDestinationReportData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateToPayDestinationReportTableData(res?.Data?.Table))
      } else {
        dispatch(updateToPayDestinationReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateToPayDestinationReportTableData([]))
    })
}

export const getReceiptRegisterReportFilter = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceiptRegisterReportFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateReceiptRegisterFilterData(res?.Data?.Table))
      } else {
        dispatch(updateReceiptRegisterFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateReceiptRegisterFilterData([]))
    })
}
export const getReceiptRegisterReportTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceiptRegisterReportTableData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == "Success") {
        dispatch(updateReceiptRegisterReportTableData(res?.Table1))
      } else {
        dispatch(updateReceiptRegisterReportTableData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateReceiptRegisterReportTableData([]))
    })
}
export const getFranchiseePendingTopayRptData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFrchseeToPayPending, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}

export const FranchiseePendingToPayUpdateData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getFrchseeToPayPendingUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getFranchiseeSettlementRptData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getFrchseeSettlemntReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}


export const FranchiseeSettlementUpdateData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getSettlementReportUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getDispatchMemoData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchMemoView, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      return resolve(res)
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      reject(error)
    })
})
}

export const getCompanyListV2 = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  const { intMode } = data
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getFranchiseeCompanyList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (intMode === 0) {
          dispatch(updateFranchiseeCompanyListV2(res.Data.Table))
        } else {
          dispatch(updateReportCompanyListV2(res.Data.Table))
        }
      }
    })
    .catch((err) => {
      updateLoader(false)
    })
  }
export const getDispatchRegisterReportFilter = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.DispatchRegisterReportFilter, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDispatchResisterFilterData(res?.Data?.Table))
      } else {
        dispatch(updateDispatchResisterFilterData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDispatchResisterFilterData([]))
    })
}

export const getDispatchRegisterReportTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.DispatchRegisterReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDispatchResisterTableData(res?.Data))
      } else {
        dispatch(updateDispatchResisterTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDispatchResisterTableData({}))
    })
}

export const getDispatchRegisterReportVehicleWiseTableData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.DispatchRegisterReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDispatchResisterVehicleWiseTableData(res?.Data))
      } else {
        dispatch(updateDispatchResisterVehicleWiseTableData({}))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDispatchResisterVehicleWiseTableData({}))
    })
}

export const GetDispatchRegistorMemoTableData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.GetDispatchRegistorMemo, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getToPayStatementReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getToPayStatementReport, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateToPayStatementReport(res?.Data?.table))
      } else {
        dispatch(updateToPayStatementReport([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    }).catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateToPayStatementReport([]))
    })
}
export const mpesaTransactionReportData = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.mpesaTransactionReportData, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateMpesaTransactionReportData(res?.Data))
      } else {
        dispatch(updateMpesaTransactionReportData([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    }).catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateMpesaTransactionReportData([]))
    })
}

export const getGoodsBalanceFilterData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getGoodsBalanceFilter, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateGoodsBalanceFilterData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
